import styled from '@emotion/styled';
import PropTypes from 'prop-types';
import Dropdown from '@comp/Dropdown/Dropdown';
import useWindowSize from '@hooks/useWindowSize';
import { Spacings, breakpoints } from '@styles/index';

const Wrapper = styled.div`
  grid-column: span 18;
  display: grid;
  grid-template-columns: repeat(18, 1fr);
  grid-column-gap: ${Spacings.SPACING_4B};
  margin-bottom: ${Spacings.SPACING_6B};

  @media only screen and (max-width: ${breakpoints.mobile}) {
    grid-column: span 11;
    grid-column-gap: ${Spacings.SPACING_2B};
    grid-template-columns: repeat(10, 1fr);
  }
`;

const StyledDropdown = styled(Dropdown)`
  @media only screen and (max-width: ${breakpoints.mobile}) {
    margin-bottom: ${Spacings.SPACING_6B};
    grid-column: span 11;
    height: ${Spacings.SPACING_12B};
  }
`;

const Filters = ({
  showFirstLevel,
  selectedFirstLevel,
  firstLevelOptions,
  handleOnFirstLevelChange,
  showSecondLevel,
  selectedSeceondLevel,
  secondLevelOptions,
  handleOnSecondLevelChange
}) => {
  const { isMobile } = useWindowSize();

  return (
    <Wrapper>
      {showFirstLevel && (
        <StyledDropdown
          options={firstLevelOptions}
          selectedOption={selectedFirstLevel}
          onOptionClick={handleOnFirstLevelChange}
          menuWidth={isMobile ? '100%' : '176px'}
          buttonWidth={isMobile ? '100%' : '176px'}
        />
      )}
      {showSecondLevel && (
        <StyledDropdown
          options={secondLevelOptions}
          selectedOption={selectedSeceondLevel}
          onOptionClick={handleOnSecondLevelChange}
          menuWidth={isMobile ? '100%' : '220px'}
          buttonWidth={isMobile ? '100%' : '220px'}
          stripLength={18}
        />
      )}
    </Wrapper>
  );
};

export default Filters;

Filters.propTypes = {
  showFirstLevel: PropTypes.bool.isRequired,
  selectedFirstLevel: PropTypes.objectOf(PropTypes.any).isRequired,
  firstLevelOptions: PropTypes.arrayOf(PropTypes.any).isRequired,
  handleOnFirstLevelChange: PropTypes.func.isRequired,
  showSecondLevel: PropTypes.bool.isRequired,
  selectedSeceondLevel: PropTypes.objectOf(PropTypes.any).isRequired,
  secondLevelOptions: PropTypes.arrayOf(PropTypes.any).isRequired,
  handleOnSecondLevelChange: PropTypes.func.isRequired
};
